export const STATS_ROUTES = {
  __ROOT__: '/stats',
}

